export enum POSTHOG_EVENTS {
	// Authentication & User Management
	LOGIN_ATTEMPTED = "login_attempted",
	LOGIN_SUCCESSFUL = "login_successful",
	LOGIN_FAILED = "login_failed",
	USER_REGISTERED = "user_registered",
	LOGOUT = "logout",
	MFA_SETUP_STARTED = "mfa_setup_started",
	MFA_SETUP_COMPLETED = "mfa_setup_completed",
	MFA_SETUP_FAILED = "mfa_setup_failed",
	PASSWORD_RESET_REQUESTED = "password_reset_requested",

	// Conversion popups
	PLAYGROUND_USER_TO_ORG_CONVERSION_POPUP = "User_to_org_conversion_pop_up",
	FREE_TO_STARTER_CONVERSION_POPUP_OPENED = "free_to_starter_conversion_popup_opened",
	FREE_TO_STARTER_CONVERSION_POPUP_CTA_CLICKED = "free_to_starter_conversion_popup_cta_clicked",

	// Organization Management
	ORGANIZATION_CREATED = "organization_created",
	ORGANIZATION_SELECTED = "organization_selected",
	ORGANIZATION_SWITCHED = "organization_switched",
	SUB_ORGANIZATION_CREATED = "sub_organization_created",
	USER_INVITED_TO_ORG = "user_invited_to_org",

	// Image Generation
	IMAGE_GENERATION_STARTED = "image_generation_started",
	IMAGE_GENERATION_COMPLETED = "image_generation_completed",
	IMAGE_GENERATION_FAILED = "image_generation_failed",

	// Image Editing
	IMAGE_EDITING_STARTED = "image_editing_started",
	IMAGE_EDITING_COMPLETED = "image_editing_completed",
	IMAGE_EDITING_FAILED = "image_editing_failed",

	// Tailored Generation (TG)
	TG_PROJECT_CREATED = "tg_project_created",
	TG_PROJECT_CREATION_FAILED = "tg_project_creation_failed",
	TG_MODEL_TRAINING_STARTED = "tg_model_training_started",
	TG_MODEL_TRAINING_COMPLETED = "tg_model_training_completed",
	TG_MODEL_TRAINING_FAILED = "tg_model_training_failed",
	TG_DATASET_UPLOADED = "tg_dataset_uploaded",
	TG_DATASET_UPLOAD_FAILED = "tg_dataset_upload_failed",

	// Product Placement
	PRODUCT_PLACEMENT_STARTED = "product_placement_started",
	PRODUCT_PLACEMENT_COMPLETED = "product_placement_completed",
	PRODUCT_PLACEMENT_FAILED = "product_placement_failed",

	// Design Editor & Campaigns
	AD_CREATION_STARTED = "ad_creation_started",
	AD_CREATION_COMPLETED = "ad_creation_completed",
	AD_CREATION_FAILED = "ad_creation_failed",
	CAMPAIGN_CREATED = "campaign_created",
	CAMPAIGN_CREATION_FAILED = "campaign_creation_failed",
	BRAND_TEMPLATE_CREATED = "brand_template_created",
	BRAND_TEMPLATE_CREATION_FAILED = "brand_template_creation_failed",
	TEMPLATE_CREATED = "template_created",
	TEMPLATE_CREATION_FAILED = "template_creation_failed",

	// Billing & Subscriptions
	SUBSCRIPTION_VIEWED = "subscription_viewed",
	SUBSCRIPTION_UPDATE_FAILED = "subscription_update_failed",
	USAGE_VIEWED = "usage_viewed",

	// Pricing & Sales
	PRICING_PAGE_VIEWED = "pricing_page_viewed",
	PLAN_COMPARISON_VIEWED = "plan_comparison_viewed",
	CONTACT_SALES_CLICKED = "contact_sales_clicked",

	// API & Documentation
	API_DOCUMENTATION_VIEWED = "api_documentation_viewed",
	API_KEY_GENERATED = "api_key_generated",
	API_KEY_GENERATION_FAILED = "api_key_generation_failed",

	// Generic Events
	ERROR_OCCURRED = "error_occurred",
	FEATURE_USED = "feature_used",
	GET_API_KEY_BUTTON_CLICKED = "GET_API_KEY_BUTTON_CLICKED",

	VIDEO_EDITING_BANNER_DISPLAYED = "video_editing_banner_displayed",
	VIDEO_EDITING_CTA_CLICKED = "video_editing_banner_cta_clicked",

	// FIBO Learn More Popup
	FIBO_LEARN_MORE_POPUP_OPENED = "fibo_learn_more_popup_opened",
	FIBO_LEARN_MORE_POPUP_CLOSED = "fibo_learn_more_popup_closed",
	FIBO_LEARN_MORE_RESOURCE_CLICKED = "fibo_learn_more_resource_clicked",

	// FIBO Generation
	FIBO_GENERATE_STARTED = "fibo_generate_started",
	FIBO_GENERATE_COMPLETED = "fibo_generate_completed",
	FIBO_GENERATE_FAILED = "fibo_generate_failed",

	// FIBO Refine
	FIBO_REFINE_STARTED = "fibo_refine_started",
	FIBO_REFINE_COMPLETED = "fibo_refine_completed",
	FIBO_REFINE_FAILED = "fibo_refine_failed",

	// API Reference Dialog
	API_REFERENCE_DIALOG_OPENED = "api_reference_dialog_opened",
	API_REFERENCE_DIALOG_CLOSED = "api_reference_dialog_closed",
	API_REFERENCE_DOCUMENTATION_CLICKED = "api_reference_documentation_clicked",
	API_REFERENCE_GET_API_KEY_CLICKED = "api_reference_get_api_key_clicked",
	API_REFERENCE_CODE_COPIED = "api_reference_code_copied",

	// FIBO Labs Header
	FIBO_LABS_BRIA_PLATFORM_CLICKED = "fibo_labs_bria_platform_clicked",
	FIBO_LABS_HUGGING_FACE_CLICKED = "fibo_labs_hugging_face_clicked",
	FIBO_LABS_GITHUB_CLICKED = "fibo_labs_github_clicked",
	FIBO_LABS_DISCORD_CLICKED = "fibo_labs_discord_clicked",
	FIBO_LABS_DOCS_CLICKED = "fibo_labs_docs_clicked",
	FIBO_LABS_RESEARCH_PAPER_CLICKED = "fibo_labs_research_paper_clicked",

	ANNOUNCEMENT_BAR_DISPLAYED = "announcement_bar_displayed",
	ANNOUNCEMENT_BAR_CTA_CLICKED = "announcement_bar_cta_clicked",
	ANNOUNCEMENT_BAR_DISMISSED = "announcement_bar_dismissed",

	// FIBO Labs Page Views
	FIBO_LAB_PAGE_VIEWED = "fibo_lab_page_viewed",
	FIBO_EDIT_LAB_PAGE_VIEWED = "fibo_edit_lab_page_viewed",

	// FIBO Edit Generation
	FIBO_EDIT_GENERATE_STARTED = "fibo_edit_generate_started",
	FIBO_EDIT_GENERATE_COMPLETED = "fibo_edit_generate_completed",
	FIBO_EDIT_GENERATE_FAILED = "fibo_edit_generate_failed",

	// FIBO Popups
	FIBO_TRY_REFINE_POPUP_OPENED = "fibo_try_refine_popup_opened",
	FIBO_TRY_REFINE_POPUP_CLOSED = "fibo_try_refine_popup_closed",
	FIBO_TRY_REFINE_POPUP_CLICKED = "fibo_try_refine_popup_clicked",
	FIBO_MASK_EDITOR_OPENED = "fibo_mask_editor_opened",
	FIBO_MASK_EDITOR_CLOSED = "fibo_mask_editor_closed",
	FIBO_MASK_EDITOR_MASK_APPLIED = "fibo_mask_editor_mask_applied",
	// FIBO 2 canvas "Embed Image" — draw an area and embed an uploaded image into it.
	// The refine that consumes it is already covered by the FIBO_REFINE_* events.
	FIBO_EMBED_DRAW_STARTED = "fibo_embed_draw_started",
	FIBO_EMBED_AREA_DRAWN = "fibo_embed_area_drawn",
	FIBO_EMBED_IMAGE_UPLOADED = "fibo_embed_image_uploaded",
	FIBO_EMBED_DRAW_CANCELLED = "fibo_embed_draw_cancelled",
	FIBO_USAGE_POPUP_OPENED = "fibo_usage_popup_opened",
	FIBO_USAGE_POPUP_CLOSED = "fibo_usage_popup_closed",

	// FIBO User Interactions
	FIBO_TAB_SWITCHED = "fibo_tab_switched",
	FIBO_IMAGE_UPLOADED = "fibo_image_uploaded",
	FIBO_REFERENCE_IMAGE_CLICKED = "fibo_reference_image_clicked",
	FIBO_RESULT_IMAGE_CLICKED = "fibo_result_image_clicked",
	FIBO_EXPERIMENT_JUMPED_TO = "fibo_experiment_jumped_to",
	FIBO_GENERATE_BUTTON_CLICKED = "fibo_generate_button_clicked",
	FIBO_REFINE_BUTTON_CLICKED = "fibo_refine_button_clicked",
	FIBO_STOP_GENERATION_CLICKED = "fibo_stop_generation_clicked",
	FIBO_EDIT_GENERATE_BUTTON_CLICKED = "fibo_edit_generate_button_clicked",
	FIBO_EDIT_STOP_GENERATION_CLICKED = "fibo_edit_stop_generation_clicked",
}
